import { createRoot } from "react-dom/client";

import "@fortawesome/fontawesome-free/css/all.css";
import "./scss/index.scss";

import App from "./App.tsx";
import { ENVIRONMENT, PROJECT_CODE } from "./shared/constants";
import { Tracing } from "./shared/Tracing";

function renderApplication() {
  const root = document.getElementById("root") as HTMLElement;
  const reactRoot = createRoot(root);

  reactRoot.render(<App />);
}

export const entryPoint = () => {
  try {
    console.debug("Starting", PROJECT_CODE, ENVIRONMENT);
    Tracing.init(PROJECT_CODE);
    renderApplication();
  } catch (error) {
    console.error("Application bootstrap error", error);
    Tracing.capture(error);
  }
};

entryPoint();
